<div mat-dialog-title class="title-text">{{title}}</div>
<div mat-dialog-content>
    <div class="message" [innerHTML]="message"></div>
</div>
<mat-dialog-actions>
    <button mat-stroked-button class="theme-error-button" (click)="dialogRef.close(ok)" translate>
        <div translate>{{exitCaption}}</div>
    </button>
    @if (waitCaption ) {
    <button mat-flat-button cdkFocusInitial (click)="dialogRef.close(false)">
        <div>{{waitCaption}}</div>
    </button>
    }
</mat-dialog-actions>